import React from 'react';
import styled from 'styled-components';

export default styled.li`
  font-size: 14px;
  margin-bottom: 5px;
  padding-left: 22px;
  position: relative;
`;
